<template>
    <ul class="nch--wiki-tree list-unstyled mb-0" :class="{ 'nch--wiki-tree__child': depth > 0 }">
        <li v-for="p in pages" :key="p.id">
            <a href="#" class="nch--wiki-tree-item d-flex align-items-center" :class="{ active: p.id === selectedId }" :style="p.id === selectedId ? { color: color.primary } : {}" @click.prevent="$emit('select', p)">
                <i class="far mr-2" :class="p.children && p.children.length ? 'fa-folder-open' : 'fa-file-alt'"></i>
                <span class="flex-grow-1 text-truncate">{{ p.title }}</span>
                <i v-if="p.locked" class="fas fa-lock text-muted small ml-1" :title="$t('wiki.page_locked')"></i>
                <i v-if="p.editing_by" class="fas fa-pen text-info small ml-1" :title="$t('wiki.editor.being_edited', { user: p.editing_by })"></i>
            </a>
            <wiki-page-tree v-if="p.children && p.children.length" :pages="p.children" :selected-id="selectedId" :depth="depth + 1" :color="color" @select="$emit('select', $event)"></wiki-page-tree>
        </li>
    </ul>
</template>

<script>
/**
 * Árvore de páginas da wiki (recursiva) na área do aluno (backlog#343).
 */
export default {
    name: 'WikiPageTree',
    props: {
        pages: { type: Array, default: () => [] },
        selectedId: { type: Number, default: null },
        depth: { type: Number, default: 0 },
        color: { type: Object, default: () => ({}) },
    },
    emits: ['select'],
};
</script>

<style>
.nch--wiki-tree__child { padding-left: 16px; }
.nch--wiki-tree-item { padding: 6px 8px; border-radius: 6px; color: #525f7f; font-size: 14px; }
.nch--wiki-tree-item:hover { background: rgba(0, 0, 0, 0.04); text-decoration: none; }
.nch--wiki-tree-item.active { background: rgba(94, 114, 228, 0.1); font-weight: 600; }
</style>
